import React from 'react';
import MasterclassIndex from '../../masterclass/prevent';

export default function () {
  return <MasterclassIndex noFixedVideo noExitIntent variant="ad" entry="reverse" />;
}
